<div *ngIf="dataLoading">
  <h3 style="text-align:center;">LOADING TO DO TODAY</h3>
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</div>

<div class="container" style="width:100%" *ngIf="!dataLoading && tasks.length">
  <mat-table
    [dataSource]="dataSource"
    matSort
    matSortActive="due"
    matSortDirection="asc"
    class="ao-job-table stack-todo-table"
  >
    <ng-container matColumnDef="task">
      <mat-header-cell *matHeaderCellDef mat-sort-header> STATUS </mat-header-cell>
      <mat-cell *matCellDef="let row" class="stack-wrap-cell ao-status">
        <strong>{{ row.task }}</strong>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="vendor">
      <mat-header-cell *matHeaderCellDef mat-sort-header> VENDOR </mat-header-cell>
      <mat-cell *matCellDef="let row" class="stack-wrap-cell">
        {{ vendorName(row.order) }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="model">
      <mat-header-cell *matHeaderCellDef mat-sort-header> MODEL </mat-header-cell>
      <mat-cell *matCellDef="let row" class="stack-wrap-cell">
        {{ productField(row.order, 'model') }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="color">
      <mat-header-cell *matHeaderCellDef mat-sort-header> COLOR </mat-header-cell>
      <mat-cell *matCellDef="let row" class="stack-wrap-cell">
        {{ productField(row.order, 'color') }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="due">
      <mat-header-cell *matHeaderCellDef mat-sort-header> DUE </mat-header-cell>
      <mat-cell *matCellDef="let row">
        <span *ngIf="row.due">{{ row.due | date:'MM/dd/yy' }}</span>
        <span *ngIf="!row.due">—</span>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="patient">
      <mat-header-cell *matHeaderCellDef> PATIENT </mat-header-cell>
      <mat-cell *matCellDef="let row" class="stack-wrap-cell">
        <button
          mat-button
          *ngIf="row.order.patient?._id"
          type="button"
          class="stack-patient-button ao-patient-name"
          [routerLink]="['/admin/patient', row.order.patient._id]"
        >
          {{ patientName(row.order) }}
        </button>
        <span *ngIf="!row.order.patient?._id">{{ patientName(row.order) }}</span>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="invoiceNumber">
      <mat-header-cell *matHeaderCellDef> INVOICE # </mat-header-cell>
      <mat-cell *matCellDef="let row" class="stack-wrap-cell ao-invoice">
        <span [class.priority-redo-invoice]="row.order?.redoPriority">{{ invoiceLabel(row.order) }}</span>
        <span class="fulfillment-ship-badge" *ngIf="isShipTask(row)">SHIP</span>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="initials">
      <mat-header-cell *matHeaderCellDef mat-sort-header> INITIALS </mat-header-cell>
      <mat-cell *matCellDef="let row" class="ao-initials">
        {{ staffInitials(row.order) || '—' }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="view">
      <mat-header-cell *matHeaderCellDef> VIEW </mat-header-cell>
      <mat-cell *matCellDef="let row" class="stack-icon-cell">
        <button
          mat-icon-button
          type="button"
          class="stack-view-order-button"
          (click)="openOrder(row.order)"
          aria-label="Open job"
        >
          <mat-icon>visibility</mat-icon>
        </button>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="log">
      <mat-header-cell *matHeaderCellDef> LOG </mat-header-cell>
      <mat-cell *matCellDef="let row" class="stack-icon-cell">
        <app-log-menu [order]="row.order" [small]="true" [alwaysShow]="true"></app-log-menu>
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row
      *matRowDef="let row; columns: displayedColumns; let i = index"
      [class.ao-row-alt]="i % 2 === 1"
    ></mat-row>
  </mat-table>
</div>
